var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 0C4.02942 0 0 4.02942 0 9C0 13.9706 4.02942 18 9 18C13.9706 18 18 13.9706 18 9C18 4.02942 13.9706 0 9 0ZM13.4048 7.73065L8.80302 11.8967C8.69022 11.9989 8.55872 12.0677 8.421 12.1038C8.30227 12.1567 8.17482 12.1841 8.04688 12.1841C7.81924 12.1841 7.59124 12.1002 7.41293 11.9311L4.57962 9.24152C4.2108 8.89137 4.19573 8.30859 4.54585 7.93977C4.89565 7.57094 5.4786 7.55569 5.8476 7.90585L8.10282 10.0465L12.1687 6.36522C12.5456 6.02393 13.1279 6.05273 13.4692 6.42978C13.8104 6.8069 13.7816 7.38918 13.4048 7.73065Z",
    fill: "#B8B8B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.04e67c92357f1fa88b4e16cf58c02bbf.svg";
export { ForwardRef as ReactComponent };